import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchMe } from '../store/slices/authSlice';
import toast from 'react-hot-toast';

export default function MicrosoftSuccessPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const access  = params.get('access');
    const refresh = params.get('refresh');
    const name    = params.get('name');
    const email   = params.get('email');
    const error   = params.get('error');

    if (error) {
      toast.error(decodeURIComponent(error));
      navigate('/login', { replace: true });
      return;
    }

    if (!access || !refresh) {
      toast.error('Microsoft login failed. Please try again.');
      navigate('/login', { replace: true });
      return;
    }

    localStorage.setItem('access_token',  access);
    localStorage.setItem('refresh_token', refresh);

    dispatch(fetchMe()).then((result) => {
      if (result.type === 'auth/me/fulfilled') {
        toast.success(`Welcome, ${name || email}!`);
        navigate('/increment-cycles', { replace: true });
      } else {
        localStorage.clear();
        toast.error('Login failed. Please try again.');
        navigate('/login', { replace: true });
      }
    });
  }, [params, navigate, dispatch]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <span className="spinner" style={{ width: 40, height: 40 }} />
    </div>
  );
}
